#import "../../../../../../common/graphql/EntityUserMessageFields.graphql"
query TravelerMessages(
  $id: UUID!
  $first: Int
  $after: Cursor
  $filter: UserMessageFilter
) {
  traveler(id: $id) {
    id
    userMessagesByEntityId(
      first: $first
      after: $after
      orderBy: _CREATED_DATE_DESC
      filter: $filter
    ) {
      nodes {
        ...EntityUserMessageFields
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
      totalCount
    }
  }
}
